import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo-arvalis.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  class: "justify-center",
  style: {"margin":"0 auto 30px auto","max-width":"600px","text-align":"center","padding-top":"0px","font-size":"12px"}
}
const _hoisted_5 = { class: "justify-center" }
const _hoisted_6 = {
  class: "justify-center",
  style: {"max-width":"600px","text-align":"center","padding-top":"0px","border-bottom":"1px solid #087b7a"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://arvalis.info/cguoad",
  style: {"text-decoration":"none","color":"#0097ac"},
  target: "_blank"
}, " CGU ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:contact@arvalis.fr?subject=Question sur le site mon-ru.arvalis.fr",
  style: {"text-decoration":"none","color":"#0097ac"}
}, " Contact ", -1)

import NotificationSnackbar from "@/components/modals/NotificationSnackbar.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import visAppBar from "./components/layouts/visAppBar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_center = _resolveComponent("center")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(visAppBar),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_v_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _imports_0,
                      alt: "Logo ARVALIS",
                      width: "300px",
                      "min-width": "200px",
                      "text-align": "center"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_router_link, {
                to: { name: 'mentionslegales' },
                style: {"text-decoration":"none","color":"#0097ac"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Mentions légales ")
                ]),
                _: 1
              }),
              _createTextVNode(" | "),
              _hoisted_7,
              _createTextVNode(" | "),
              _hoisted_8,
              _createTextVNode(" | Mon Réservoir Utilisable est un outil d'ARVALIS - Institut du Végétal ")
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(NotificationSnackbar),
      _createVNode(ErrorModal)
    ]),
    _: 1
  }))
}
}

})